<template>
  <div>
    <a-row>
      <a-col
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
      >
        <a-card
          size="small"
          style="margin-top: 10px; border-radius: 5px; border-color: #c9c9c9"
          hoverable
          :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
        >
          <a slot="title" class="guider" style="font-size: 20px">
            Basic information of {{ this.$route.query.gene }}
          </a>
          <a-descriptions bordered size="small">
            <a-descriptions-item label="Gene">
              {{ this.gene }}
            </a-descriptions-item>
            <a-descriptions-item label="Ensembl ID">
              {{ this.ensgId }}
            </a-descriptions-item>
            <a-descriptions-item label="Gene type">
              {{ this.genetype }}
            </a-descriptions-item>
            <a-descriptions-item label="Alias">
              {{ this.alias }}
            </a-descriptions-item>
            <a-descriptions-item label="Entrez ID">
              {{ this.geneId }}
            </a-descriptions-item>
            <a-descriptions-item label="Gene tag">
              <!-- 这个地方要进行判断 -->
              <div style="text-align: center" v-if="this.genetag != null">
                <div
                  v-for="(index, element) in this.genetag.split(',')"
                  :key="index"
                  :value="element"
                >
                  <a-tag
                    v-if="index == 'RBP'"
                    color="pink"
                    style="margin-bottom: 2px"
                  >
                    {{ index }}
                  </a-tag>
                  <a-tag
                    v-if="index == 'TF'"
                    color="red"
                    style="margin-bottom: 2px"
                  >
                    {{ index }}
                  </a-tag>
                  <a-tag
                    v-if="index == 'Metabolism'"
                    color="orange"
                    style="margin-bottom: 2px"
                  >
                    {{ index }}
                  </a-tag>
                  <a-tag
                    v-if="index == 'Essential'"
                    color="green"
                    style="margin-bottom: 2px"
                  >
                    Essential gene
                  </a-tag>
                  <a-tag
                    v-if="index == 'E3'"
                    color="cyan"
                    style="margin-bottom: 2px"
                  >
                    {{ index }}
                  </a-tag>
                </div>
              </div>
              <!-- <a-tag color="red">{{ this.genetag }}</a-tag> -->
            </a-descriptions-item>
            <a-descriptions-item label="Summary">
              {{ this.summary }}
            </a-descriptions-item>
          </a-descriptions>
        </a-card>
      </a-col>
      <a-col
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
      >
        <a-card
          size="small"
          style="margin-top: 10px; border-radius: 5px; border-color: #c9c9c9"
          hoverable
          :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
        >
          <a slot="title" class="guider" style="font-size: 20px; float: left">
            Venn plot of predicted drugs
          </a>
          <a-row>
            <a-col
              ><a-alert
                message="The prediction results are for reference only. We recommend selecting the intersection of two or more datasets with higher scores for further experimental validation."
                banner
              />
            </a-col>
            <a-col
              :sm="{ span: 24 }"
              :md="{ span: 12 }"
              :xl="{ span: 12 }"
              style="margin-top: 15px"
            >
              <div style="text-align: center">
                <img
                  alt="example"
                  height="80%"
                  width="80%"
                  :src="this.svgSrc"
                /></div
            ></a-col>
            <a-col :sm="{ span: 24 }" :md="{ span: 12 }" :xl="{ span: 12 }">
              <div style="color: black; font-size: 20px">
                Select venn partitions to view drug list:
                <a-select
                  style="width: 100%"
                  :value="value"
                  @search="handleSearch"
                  @change="handleChange"
                >
                  <a-select-option
                    v-for="(index, element) in this.optionsL"
                    :key="index"
                    :value="element"
                    >{{ index }}</a-select-option
                  >
                </a-select>
                <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 24 }"
                  ><listTable v-bind:value="this.value"
                /></a-col></div
            ></a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import axios from "axios";
import listTable from "./01drugGenelist.vue";

export default {
  components: { listTable },
  data() {
    return {
      //basic infor
      gene: "",
      ensgId: "",
      genetype: "",
      alias: "",
      geneId: "",
      genetag: "",
      summary: "",
      //drug
      svgSrc:
        "http://research.gzsys.org.cn/perturbdb/data/drug/tiff/" +
        this.$route.query.gene +
        "venn.svg",
      //options
      optionsL: [],
      value: "",
      //表格:
    };
  },
  methods: {
    handleChange(value) {
      this.value = this.optionsL[value];
    },
  },
  mounted() {
    //查询基本信息
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_basic.php",
        {
          params: {
            genename: this.$route.query.gene,
          },
        }
      )
      .then((response) => {
        //同一转一下.
        this.gene = response.data[0]["genename"];
        this.ensgId = response.data[0]["ensgId"];
        this.genetype = response.data[0]["genetype"];
        this.alias = response.data[0]["alias"]
          .replaceAll("|", ",")
          .substring(
            1,
            response.data[0]["alias"].replaceAll("|", ",").length - 1
          );
        this.geneId = response.data[0]["geneid"];
        this.genetag = response.data[0]["genetag"];
        this.summary = response.data[0]["summary"];
      });
    //查询下拉列表
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/drug/gene/searchOptions.php",
        {
          params: {
            gene: this.$route.query.gene,
          },
        }
      )
      .then((response) => {
        //同一转一下.
        this.optionsL = response.data.sort();
        console.log(response.data);
        console.log(this.optionsL);
      });
  },
};
</script>

<style></style>
